import { forwardRef } from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
	size?: number | string;
}

export const BriefIcon = forwardRef<SVGSVGElement, IconProps>(
	({ className, size = 24, ...props }, ref) => (
		<svg
			ref={ref}
			className={className}
			width={size}
			height={size}
			viewBox="0 0 23 23"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M19.1161 5.30917L15.7811 1.96458C14.5161 0.699583 12.8295 0 11.0374 0H6.70573C4.06073 0 1.91406 2.14667 1.91406 4.79167V18.2083C1.91406 20.8533 4.06073 23 6.70573 23H16.2891C18.9341 23 21.0807 20.8533 21.0807 18.2083V10.0529C21.0807 8.26083 20.3811 6.57417 19.1161 5.30917ZM17.7649 6.66042C18.0716 6.96708 18.3303 7.3025 18.5411 7.66667H14.382C13.8549 7.66667 13.4236 7.23542 13.4236 6.70833V2.54917C13.7878 2.76 14.1232 3.01875 14.4299 3.32542L17.7649 6.67V6.66042ZM19.1641 18.2083C19.1641 19.7896 17.8703 21.0833 16.2891 21.0833H6.70573C5.12448 21.0833 3.83073 19.7896 3.83073 18.2083V4.79167C3.83073 3.21042 5.12448 1.91667 6.70573 1.91667H11.0278C11.1811 1.91667 11.3441 1.91667 11.4974 1.93583V6.70833C11.4974 8.28958 12.7911 9.58333 14.3724 9.58333H19.1449C19.1641 9.73667 19.1641 9.89 19.1641 10.0529V18.2083ZM16.0207 12.6883L14.6599 18.1125C14.5161 18.6971 14.0082 19.1187 13.4045 19.1571C12.8007 19.1954 12.2449 18.8504 12.0245 18.285L11.4974 16.9625L10.9703 18.285C10.7595 18.8217 10.2516 19.1571 9.68615 19.1571C9.6574 19.1571 9.61906 19.1571 9.59031 19.1571C8.98656 19.1187 8.48823 18.6971 8.3349 18.1029L6.98365 12.6787C6.85906 12.1612 7.16573 11.6438 7.68323 11.5192C8.19115 11.3946 8.71823 11.7013 8.84281 12.2188L9.80115 16.0521L10.6157 14.0108C10.7595 13.6467 11.1141 13.4071 11.507 13.4071C11.8999 13.4071 12.2545 13.6467 12.3982 14.0108L13.2032 16.0521L14.1711 12.2188C14.2957 11.7013 14.8228 11.3946 15.3307 11.5192C15.8482 11.6438 16.1549 12.1708 16.0303 12.6787L16.0207 12.6883Z" />
		</svg>
	),
);

BriefIcon.displayName = "BriefIcon";

// Meta logo, single-colour so it follows the icon tile's text colour.
export const MetaIcon = forwardRef<SVGSVGElement, IconProps>(
	({ className, size = 24, ...props }, ref) => (
		<svg
			ref={ref}
			className={className}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M6.915 4.03c-1.968 0-3.683 1.28-4.871 3.113C.704 9.208 0 11.883 0 14.449c0 .706.07 1.369.21 1.973a6.624 6.624 0 0 0 .265.86 5.297 5.297 0 0 0 .371.761c.696 1.159 1.818 1.927 3.593 1.927 1.497 0 2.633-.671 3.965-2.444.76-1.012 1.144-1.626 2.663-4.32l.756-1.339.186-.325c.061.1.121.196.183.3l2.152 3.595c.724 1.21 1.665 2.556 2.47 3.314 1.046.987 1.992 1.22 3.06 1.22 1.075 0 1.876-.355 2.455-.843a3.743 3.743 0 0 0 .81-.973c.542-.939.861-2.127.861-3.745 0-2.72-.681-5.357-2.084-7.45-1.282-1.912-2.957-2.93-4.716-2.93-1.047 0-2.088.467-3.053 1.308-.652.57-1.257 1.29-1.82 2.05-.69-.875-1.335-1.547-1.958-2.056-1.182-.966-2.315-1.303-3.454-1.303zm10.16 2.053c1.147 0 2.188.758 2.992 1.999 1.132 1.748 1.647 4.195 1.647 6.4 0 1.548-.368 2.9-1.839 2.9-.58 0-1.027-.23-1.664-1.004-.496-.601-1.343-1.878-2.832-4.358l-.617-1.028a44.908 44.908 0 0 0-1.255-1.98c.07-.109.141-.224.211-.327 1.12-1.667 2.118-2.602 3.358-2.602zm-10.201.553c1.265 0 2.058.791 2.675 1.446.307.327.737.871 1.234 1.579l-1.02 1.566c-.757 1.163-1.882 3.017-2.837 4.338-1.191 1.649-1.81 1.817-2.486 1.817-.524 0-1.038-.237-1.383-.794-.263-.426-.464-1.13-.464-2.046 0-2.221.63-4.535 1.66-6.088.454-.687.964-1.226 1.533-1.533a2.264 2.264 0 0 1 1.088-.285z" />
		</svg>
	),
);

MetaIcon.displayName = "MetaIcon";

// TikTok logo, single-colour like MetaIcon.
export const TikTokIcon = forwardRef<SVGSVGElement, IconProps>(
	({ className, size = 24, ...props }, ref) => (
		<svg
			ref={ref}
			className={className}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
		</svg>
	),
);

TikTokIcon.displayName = "TikTokIcon";
